<form nz-form style="padding-top:12px;padding-right:12px"  autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Tên chính sách/chế độ</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="itemPolicy.policyName"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập tên" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Mức phụ cấp/tháng</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <nz-input-number [(ngModel)]="itemPolicy.policyRatio" [ngModelOptions]="{standalone: true}"  nzPlaceHolder="Nhập phụ cấp"></nz-input-number>
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Ngày cấp</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback >
            <nz-date-picker [nzFormat]="'dd/MM/yyyy'" [(ngModel)]="itemPolicy.policyDate"  [ngModelOptions]="{standalone: true}"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24"  >Cơ quan cấp</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="itemPolicy.issuedBy"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập tên cơ quan...">
        </nz-form-control>
        </nz-form-item >
      </div> 
 
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Ghi chú</nz-form-label> 
            <input nz-input  [(ngModel)]="itemPolicy.note"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập ghi chú..."> 
        </nz-form-item >
      </div>


     
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>